import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ImageUploadResponse, ImageUploadRequest } from '../interfaces/image-upload.interface';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {
  private readonly uploadEndpoint = `${environment.fastApiBaseUrl}/images/upload`;

  constructor(private http: HttpClient) {}

  /**
   * Upload an image file to S3 via the API
   * @param companyGuid - The company GUID
   * @param imageFile - The image file to upload
   * @param tagName - The tag name for the image
   * @returns Observable of the upload response
   */
  uploadImage(companyGuid: string, imageFile: File, tagName: string): Observable<ImageUploadResponse> {
    const formData = new FormData();
    formData.append('company_guid', companyGuid);
    formData.append('image_file', imageFile);
    formData.append('tag_name', tagName);

    return this.http.post<ImageUploadResponse>(this.uploadEndpoint, formData).pipe(
      map(response => {
        if (!response.success) {
          throw new Error(response.message || 'Upload failed');
        }
        return response;
      }),
      catchError(error => {
        console.error('Image upload error:', error);
        return throwError(() => new Error(error.error?.message || 'Failed to upload image'));
      })
    );
  }

  
}
